// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1P9Ks","title":"Images45_title__3zXH3","images":"Images45_images__8IlIv"};